import { useNavigate } from 'react-router-dom';

const ReturnPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6">
      <div className="max-w-2xl bg-black border border-white rounded-lg shadow-xl p-8">
        <div className="flex items-center mb-6">
          <button
            onClick={() => navigate('/')}
            className="w-10 h-10 rounded-full bg-white text-black flex items-center justify-center shadow-md hover:bg-gray-200 transition duration-300 mr-4"
            aria-label="Back to Home"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-3xl font-bold text-white">Return Policy</h1>
        </div>
        <p className="text-white mb-4">
          You can raise a complaint for damaged products. Our strict monitoring service ensures that customers recieve full satisfaction while preventing fraudulent returns inorder to protect Layne Red's reputation.
        </p>
        <p className="text-white">
          For assistance, contact our support team via email at <a href="mailto:official.laynered@gmail.com" className="text-white underline hover:text-gray-300">official.laynered@gmail.com</a> or phone at <a href="tel:+919207207469" className="text-white underline hover:text-gray-300">+91 92072 07469</a>.
        </p>
      </div>
    </div>
  );
};

export default ReturnPolicy;